import type { ScaleLinear } from 'd3';
import { AnimatePresence } from 'motion/react';
import Annotation from '@/components/Charts/ui/Annotation';
import type { Margin } from '@/types/chart';

type Props = {
  chartValues: number[];
  chartMargins: Margin;
  chartScales: {
    yScale: ScaleLinear<number, number>;
    minY: number;
    maxY: number;
  };
  showAnnotations: boolean;
  unit: string;
};
export const AnnotationList = ({ chartValues, chartScales, chartMargins, showAnnotations = false, unit }: Props) => {
  const average = chartValues.reduce((a, b) => a + b, 0) / chartValues.length;

  const graphValues = [
    {
      label: 'Lägsta',
      value: chartScales.minY,
    },
    {
      label: 'Högsta',
      value: chartScales.maxY,
    },
    { label: 'Genomsnitt', value: Math.round(average) },
  ];
  return (
    <AnimatePresence>
      {showAnnotations &&
        graphValues.map((annotation, i) => (
          <Annotation
            label={annotation.label}
            position={chartScales.yScale(annotation.value)}
            marginLeft={chartMargins.left}
            value={annotation.value}
            key={`annotation-${annotation.label}`}
            index={i}
            decimals={2}
            unit={unit}
          />
        ))}
    </AnimatePresence>
  );
};
